import { PURPOSES_ID } from '@backmarket/nuxt-module-tracking/didomi/config'
import { useDataConsent } from '@backmarket/nuxt-module-tracking/useDataConsent'

import { useClearBrowsingHistory } from './useClearBrowsingHistory'

export function useBrowsingHistoryConsent() {
  const { isDidomiEnabled, getUserConsentForPurpose } = useDataConsent()
  const { clearBrowsingHistory } = useClearBrowsingHistory()

  function clearBrowsingHistoryWithoutConsent() {
    if (getUserConsentForPurpose(PURPOSES_ID.personalization)) return
    void clearBrowsingHistory()
  }

  if (!isDidomiEnabled) return

  window.didomiOnReady = window.didomiOnReady || []
  window.didomiOnReady.push(() => {
    clearBrowsingHistoryWithoutConsent()
    window.Didomi?.on?.('consent.changed', clearBrowsingHistoryWithoutConsent)
  })
}
